import { AssetType } from '../types/asset-type.interface';
import { BusinessRuleType, EntityDefinition } from '../types/entity-definition.interface';

export const assetTypeDefinition: EntityDefinition<AssetType> = {
  entityType: 'AssetType',
  i18nBase: 'entities.assetType',
  list: {
    columns: [
      {
        field: 'name',
        headerKey: 'entities.assetType.fields.name',
        sortable: true,
        filterable: true,
        class: 'w-full min-w-[200px]',
        contentClass: 'line-clamp-1',
        showTooltip: true,
      },
    ],
  },
  fields: [{ field: 'name', labelKey: 'entities.assetType.fields.name', required: true, type: 'text', minLength: 3, maxLength: 50 }],
  validationRules: [
    {
      type: BusinessRuleType.DELETE_VALIDATION,
      rule: (entity: AssetType) => !entity.isUsed,
      errorMessageKey: 'entities.assetType.messages.deleteError',
    },
    {
      type: BusinessRuleType.CREATE_VALIDATION,
      rule: (entity: AssetType, store) => {
        if (!store) return true;
        const assetTypes = store.getData<AssetType>('AssetType')();
        return !assetTypes.some(type => type.name.toLowerCase().trim() === entity.name.toLowerCase().trim());
      },
      errorMessageKey: 'entities.assetType.messages.duplicateError',
    },
    {
      type: BusinessRuleType.EDIT_VALIDATION,
      rule: (entity: AssetType, store) => {
        if (!store) return true;
        const assetTypes = store.getData<AssetType>('AssetType')();
        return !assetTypes.some(type => type.name.toLowerCase().trim() === entity.name.toLowerCase().trim() && type.id !== entity.id);
      },
      errorMessageKey: 'entities.assetType.messages.duplicateError',
    },
  ],
  actionButtons: {
    parent: {
      add: true,
      edit: true,
    },
  },
  formOptions: {
    showDeleteButton: true,
  },
  messages: {
    dialogTitles: {
      create: () => 'entities.assetType.messages.createTitle',
      edit: () => 'entities.assetType.messages.editTitleWithName',
      delete: () => 'common.confirmations.deleteTitleWithName',
    },
    buttons: {
      add: () => 'entities.assetType.messages.addButton',
      create: () => 'entities.assetType.messages.addButton',
      edit: () => 'entities.assetType.messages.editTitleWithName',
      delete: () => 'entities.assetType.messages.deleteTitle',
    },
    confirmDelete: () => 'entities.assetType.messages.deleteConfirm',
  },
  enableFiltering: true,
};
